export const BASE_PATH = '/providers' as const

const PAY_PROVIDER_PATH = `${BASE_PATH}/pay_provider` as const

export const ProviderPaths = {
  index: BASE_PATH,
  pay_provider: {
    index: PAY_PROVIDER_PATH,
    select_provider: `${PAY_PROVIDER_PATH}/select_provider`,
    confirm_provider: `${PAY_PROVIDER_PATH}/confirm_provider`,
    add_details: `${PAY_PROVIDER_PATH}/add_details`,
    upload_documents: `${PAY_PROVIDER_PATH}/upload_documents`,
    choose_purses: `${PAY_PROVIDER_PATH}/choose_purses`,
    expense_type: `${PAY_PROVIDER_PATH}/expense_type`,
    review_and_submit: `${PAY_PROVIDER_PATH}/review_and_submit`,
    provider_payment_success: `${PAY_PROVIDER_PATH}/provider_payment_success`,
    expense_allocation: `${PAY_PROVIDER_PATH}/expense_allocation`,
  } as const,
} as const

export type ProviderPathsType = typeof ProviderPaths
export type PayProviderPaths = typeof ProviderPaths['pay_provider'][keyof typeof ProviderPaths['pay_provider']]

